module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-right-pink-24d5b035b947b962ed55233e45267002.svg";